import { type ApiBranding, type ApiUserPartnershipInformation } from '@Model';

// @ai-generated 2026-10-12T14:25:59+00:00 by niklas.eicker@tngtech.com using Claude Opus 5.5 (1M context)
/** The partnerships whose mandant owns the custom domain, or all of them on the default domain. */
export function filterCustomDomainPartnerships(
    partnerships: ApiUserPartnershipInformation[],
    brandings: ApiBranding[],
    customDomain: string | undefined,
): ApiUserPartnershipInformation[] {
    if (!customDomain) {
        return partnerships;
    }

    const mandantIds = new Set(brandings.filter((b) => b.domain === customDomain).map((b) => b.mandant_id));
    return partnerships.filter((p) => mandantIds.has(p.mandant_id));
}
